module.exports = __webpack_public_path__ + "img/fabuchenggong.ffd7a936.png";